import { useEffect, useState } from "react";
import { ChevronDown, X } from "lucide-react";

export default function SaveImageModal({
    onSave,
    myfolders = [],
    image_name,
    setImageName,
    folder,
    setFolder,
    open,
    onClose,
    setShowSavedModal,
}) {
    const [visible, setVisible] = useState(false);
    const [folderOpen, setFolderOpen] = useState(false);

    const isMobile = window.innerWidth < 768;

    useEffect(() => {
        if (open) {
            setVisible(true);
        } else {
            setTimeout(() => setVisible(false), 200);
        }
    }, [open]);

    if (!open && !visible) return null;

    return (
        <div style={styles.backdrop} onClick={onClose}>
            <div
                style={{
                    ...styles.modal,
                    width: isMobile ? "95%" : styles.modal.width,
                    padding: isMobile ? "18px 16px" : styles.modal.padding,
                    ...(open ? styles.modalIn : styles.modalOut),
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Optional close button */}
                {isMobile && (
                    <X
                        size={22}
                        style={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            cursor: "pointer",
                            color: "#F7941D",
                        }}
                        onClick={onClose}
                    />
                )}

                <h2 style={{ ...styles.title, fontSize: isMobile ? 20 : styles.title.fontSize }}>
                    Save Image
                </h2>
                <p style={{ ...styles.subtitle, fontSize: isMobile ? 14 : styles.subtitle.fontSize }}>
                    Give your image a name to save it for later
                </p>

                {/* Folder */}
                <label style={{ ...styles.label, fontSize: isMobile ? 13 : styles.label.fontSize }}>
                    Select Folder
                </label>

                <div style={styles.fieldWrapper}>
                    <div
                        style={{
                            ...styles.dropdown,
                            height: isMobile ? 48 : styles.dropdown.height,
                            borderRadius: isMobile ? 12 : styles.dropdown.borderRadius,
                        }}
                        onClick={() => setFolderOpen(!folderOpen)}
                    >
                        <span style={{ color: folder ? "#fff" : "#9CA3AF" }}>
                            {folder?.name || "Choose a folder..."}
                        </span>
                        <ChevronDown size={18} color="#F7941D" />
                    </div>

                    {folderOpen && (
                        <div style={{ ...styles.dropdownMenu, maxHeight: isMobile ? 180 : 220 }}>
                            {myfolders.map((f) => (
                                <div
                                    key={f.ID}
                                    onClick={() => {
                                        setFolder(f);
                                        setFolderOpen(false);
                                    }}
                                    style={{
                                        ...styles.dropdownItem,
                                        ...(folder?.ID === f.ID ? styles.dropdownItemActive : {}),
                                    }}
                                >
                                    {f.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Image Name */}
                <label style={{ ...styles.label, fontSize: isMobile ? 13 : styles.label.fontSize }}>
                    Image Name
                </label>
                <input
                    value={image_name}
                    onChange={(e) => setImageName(e.target.value)}
                    placeholder="e.g., Summer Sale Banner"
                    style={{
                        ...styles.input,
                        height: isMobile ? 48 : styles.input.height,
                        fontSize: isMobile ? 14 : styles.input.fontSize,
                        borderRadius: isMobile ? 12 : styles.input.borderRadius,
                    }}
                />



                {/* Footer */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row", // stack on mobile
                        gap: isMobile ? 12 : 16,
                        marginTop: isMobile ? 12 : 0,
                    }}
                >
                    <button
                        style={{
                            width: "100%", // full width on mobile
                            minHeight: isMobile ? 52 : 56, // taller and consistent
                            borderRadius: 14,
                            border: "none",
                            background: "#374151",
                            color: "#fff",
                            fontSize: isMobile ? 16 : 18,
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                        onClick={onClose}
                    >
                        Cancel
                    </button>

                    <button
                        style={{
                            width: "100%", // full width on mobile
                            minHeight: isMobile ? 52 : 56,
                            borderRadius: 14,
                            border: "none",
                            background: "linear-gradient(135deg, #EE4037, #F7941D)",
                            color: "#fff",
                            fontSize: isMobile ? 16 : 18,
                            fontWeight: 700,
                            cursor: "pointer",
                        }}
                        onClick={onSave}
                    >
                        Save Image
                    </button>
                </div>


            </div>
        </div>
    );
}

// Only overrides and mobile-friendly tweaks kept
const styles = {
    backdrop: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },

    modal: {
        width: 420,
        padding: "24px 26px",
        borderRadius: 22,
        background: "linear-gradient(180deg, #0B0F14, #0E131A)",
        border: "2px solid #2B3440",
        transform: "translateY(20px) scale(0.96)",
        opacity: 0,
        transition: "all 0.25s ease",
        position: "relative",
        boxSizing: "border-box",
    },

    modalIn: {
        transform: "translateY(0) scale(1)",
        opacity: 1,
    },

    modalOut: {
        transform: "translateY(20px) scale(0.96)",
        opacity: 0,
    },

    title: {
        fontSize: 24,
        fontWeight: 700,
        marginBottom: 10,
        textAlign: "left",
        color: "white",
    },

    subtitle: {
        fontSize: 16,
        color: "#9CA3AF",
        marginBottom: 26,
        textAlign: "left",
    },

    label: {
        fontSize: 15,
        fontWeight: 600,
        marginBottom: 8,
        display: "block",
        textAlign: "left",
        color: "white",
    },

    fieldWrapper: {
        position: "relative",
        width: "100%",
        marginBottom: 18,
    },

    dropdown: {
        width: "100%",
        height: 54,
        borderRadius: 14,
        border: "2px solid #2B3440",
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        background: "#0F1419",
        color: "#fff",
        boxSizing: "border-box",
    },

    dropdownMenu: {
        position: "absolute",
        top: 60,
        left: 0,
        width: "100%",
        background: "#0F1419",
        borderRadius: 14,
        border: "2px solid #2B3440",
        maxHeight: 220,
        overflowY: "auto",
        zIndex: 20,
    },

    dropdownItem: {
        padding: "14px 16px",
        fontSize: 15,
        cursor: "pointer",
        color: "#E5E7EB",
        borderBottom: "1px solid #1F2937",
    },

    dropdownItemActive: {
        background: "linear-gradient(90deg, #EE4037, #F7941D)",
        color: "#fff",
        fontWeight: 600,
    },

    input: {
        width: "100%",
        height: 54,
        borderRadius: 14,
        border: "2px solid #2B3440",
        padding: "0 16px",
        background: "#0F1419",
        color: "#fff",
        fontSize: 16,
        outline: "none",
        boxSizing: "border-box",
        marginBottom: 28,
    },

    footer: {
        display: "flex",
        gap: 16,
    },

    cancelBtn: {
        flex: 1,
        height: 56,
        borderRadius: 16,
        border: "none",
        background: "#374151",
        color: "#fff",
        fontSize: 18,
        fontWeight: 600,
        cursor: "pointer",
    },

    saveBtn: {
        flex: 1.4,
        height: 56,
        borderRadius: 16,
        border: "none",
        background: "linear-gradient(135deg, #EE4037, #F7941D)",
        color: "#fff",
        fontSize: 18,
        fontWeight: 700,
        cursor: "pointer",
    },
};
